import React, { useState, useRef, Fragment } from "react";

import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom"
import { Segment } from "semantic-ui-react";
import { isEqual } from 'lodash'

import {
  Card,
  Button,
  Tooltip,
  Popconfirm,
  Space
} from "antd";

import {
  CalendarOutlined,
  DeleteTwoTone,
  EditTwoTone
} from '@ant-design/icons';

import moment from "moment";

import { setChangelogData } from './changelogSlice'
import { setChangelogModal } from '../../components/Modals/modalsSlice'
import fire from "../../components/App/fire";
import { Editor } from "react-draft-wysiwyg";

import { rand } from '../../utils/rand'

const style = {
  wordBreak: "break-word"
};

const Changelog = () => {
  const [changelogFireData, setChangelogFireData] = useState(null)
  const emphasizedChanges = useRef(null)
  const changelogDataRedux = useSelector(state => state.changelog.data)
  const dispatch = useDispatch()
  const location = useLocation()

  if (emphasizedChanges && emphasizedChanges.current) {
    window.scrollTo(0, emphasizedChanges.current.offsetTop)
  }

  // Getting data from firebase
  fire
    .database()
    .ref('changelog')
    .orderByKey()
    .on('value', snapshot => {
      if (!changelogFireData) {
        const newChangelogData = snapshot.val()
        setChangelogFireData(newChangelogData)
      }
    });

  if (!changelogFireData) return <Segment loading basic />

  // if different, set new changelog from firebase to redux
  if (!isEqual(changelogFireData, changelogDataRedux)) {
    dispatch(setChangelogData(changelogFireData))
  }

  const handleDeleteChangelog = (date) => {
    fire
      .database()
      .ref(`${"changelog"}/${date}`)
      .remove();
  }

  const handleEdit = (dateIndex) => {
    dispatch(setChangelogModal({ open: true, action: 'update', date: dateIndex, contentState: JSON.parse(changelogDataRedux[dateIndex]) }))
  }

  const renderChangelogContent = () => {
    const changelogContents = [];
    for (const dateIndex in changelogFireData) {
      // from firebase string value to JSON format
      const parsedContent = JSON.parse(changelogFireData[dateIndex])
      const changelogContent = (
        <Editor
          editorStyle={style}
          toolbarStyle={style}
          initialContentState={parsedContent}
          toolbarHidden
          readOnly
        />
      )
      let refs = {}
      const addRef = location.hash.includes(dateIndex)
      if (addRef) {
        refs = {
          ref: emphasizedChanges
        }
      }
      let content = (
        <div key={dateIndex} id={dateIndex} {...refs}>
          <Card bordered={false}>
            <Space direction='horizontal'>
              <CalendarOutlined />
              {moment(dateIndex).format("MMMM D, YYYY")}
            </Space>
            {localStorage.getItem("Visp.logged-in-as") === rand(true) && (
              <Fragment>
                <Tooltip title="Edit">
                  <Button
                    icon={<EditTwoTone />}
                    style={{ border: "none" }}
                    onClick={() => handleEdit(dateIndex)}
                  />
                </Tooltip>
                <Tooltip title="Delete">
                  <Popconfirm
                    placement="rightTop"
                    title="Delete this changelog?"
                    cancelText="No"
                    okText="Yes"
                    onConfirm={() => handleDeleteChangelog(dateIndex)}
                  >
                    <Button icon={<DeleteTwoTone twoToneColor='#f81d22' />} style={{ border: "none" }} />
                  </Popconfirm>
                </Tooltip>
              </Fragment>
            )}
            {changelogContent}
          </Card>
        </div>
      );
      changelogContents.push(content);
    }
    return changelogContents.reverse();
  };

  return (
    <div>
      <h1 style={{ color: "#2185d0" }}>VISP GraphQL API Changes</h1>
      {renderChangelogContent()}
    </div>
  )
}

export default Changelog